import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import DossierDocuments from './DossierDocuments';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class DossierForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            title: '',
            active: false,
            dossierTypes: [],
            dossierTargets: [],
            dossier: null,
            selectedDocuments: []
        };
        this.save = this.save.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.dossierTarget = React.createRef();
        this.dossierType = React.createRef();
        this.dossierDocuments = React.createRef();
    }

    async componentDidMount() {
        const lang = this.context.lang; 
        await this.getDossierTypes()
        await this.getDossierTargets()

        if (this.props.dossier_id != null) {
            this.getDossier(this.props.dossier_id)
        }

        if (this.props.copy_dossier_id != null) {
            this.getDossier(this.props.copy_dossier_id)
        }

        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                title: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_4')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            this.setState({active: true});
            const lang = this.context.lang;
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    if (this.dossierDocuments.current.state.selectedDocuments.length > 0) {
                        this.save();
                    } else {
                        swal.fire({
                            text:  lang.get('messages.debes_seleccionar_al_menos_una_plantilla_de_documento'),
                            icon: "info",
                            buttonsStyling: false,
                            
                            confirmButtonText:  lang.get('messages.aceptar'),
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        })
                    }
                }
            });
        });
    }

    handleTitleChange(e) {
        this.setState({ title: e.target.value });
    }

    async getDossierTypes() {
        const res = await axios.get('/api/dossiers/types')
        this.setState({dossierTypes: res.data})
    }

    async getDossierTargets() {
        const res = await axios.get('/api/dossiers/targets')
        this.setState({dossierTargets: res.data})
    }

    async getDossier(id) {
        const res = await axios.get('/api/dossiers/' + id)
        this.setState({dossier: res.data, title: res.data.title})

        if (this.props.copy_dossier_id != null) {
            this.setState({title: res.data.title + " - Copia"})
        }

        this.dossierTarget.current.value = res.data.dossier_targets_id
        this.dossierType.current.value = res.data.dossier_type_id

        const selectedDocuments = this.state.dossier.documents.map((d) => {
            return {
                id: d.id,
                title: d.title,
            }
        })

        this.setState({
            selectedDocuments: selectedDocuments
        })
    }

    save() {
        window.blockUI();
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }

        const documents = this.dossierDocuments.current.state.selectedDocuments.map(d => d.id)
        const params = JSON.stringify({
            title: this.state.title,
            dossier_target: this.dossierTarget.current.value,
            dossier_type: this.dossierType.current.value,
            active: this.state.active,
            documents: documents
        })
        if (this.props.dossier_id != null) {
            this.update(params)
        } else {
            this.create(params)
        }
    }

    async create(params) {
        await axios.post(
            '/api/dossiers',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }

            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/dossiers';
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async update(params) {
        await axios.put(
            '/api/dossiers/' + this.props.dossier_id,
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnPublish'));

            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/dossiers';
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnPublish'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    confirmDelete() {
        swal.fire({
            text: "¿Desea continuar con el borrado?",
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-danger"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete();
            }
        });
    }

    async delete() {
        window.blockUI();
        await axios.delete(
            '/api/dossiers/' + this.props.dossier_id,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/dossiers';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    render() {
        const { lang } = this.context; 
        return (
            <form id="frm">
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                    {this.props.dossier_id != null && this.state.dossier != null ? this.state.dossier.title : lang.get('messages.nueva_plantilla_de_expediente')}
                                    &nbsp;
                                    <small className="text-muted font-weight-bold">{lang.get('messages.selecciona_los_documentos_para_esta_plantilla')}</small>
                                </h5>
                            </div>
                        </div>
                        {
                            this.props.dossier_id != null && <div className="d-flex align-items-center flex-wrap">
                                <a href={"/dossiers/new?d=" + this.props.dossier_id} className="btn btn-fixed btn-primary font-size-sm">{lang.get('messages.duplicar_expediente')}</a>
                            </div>
                        }
                    </div>
                </div>

                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-4 form-group">
                                        <label htmlFor="title" className="text-left">{lang.get('messages.nombre')}</label>
                                        <input id="title" type="text" className="form-control form-control-solid" name="title" value={this.state.title} required autoFocus onChange={this.handleTitleChange}/>
                                    </div>
                                    <div className="col-sm-4 form-group">
                                        <label htmlFor="dossier_targets_id " className="text-left">{lang.get('messages.expediente_para')}</label>
                                        <select ref={this.dossierTarget} id="dossier_targets_id" name="dossier_targets_id" className="form-control form-control-solid">
                                            {this.state.dossierTargets.map((t, i) => {
                                                return <option key={i} value={t.id}>{lang.get('messages.'+t.name.toLowerCase())}</option>;
                                            })} 
                                        </select>
                                    </div>
                                    <div className="col-sm-4 form-group"> 
                                        <label htmlFor="dossier_type " className="text-left">{lang.get('messages.tipo_de_expediente')}</label>
                                        <select ref={this.dossierType} id="dossier_type " name="dossier_type" className="form-control form-control-solid">
                                            {this.state.dossierTypes.map((t, i) => {
                                                return <option key={i} value={t.id}>{lang.get('messages.'+t.title.toLowerCase())} </option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <DossierDocuments ref={this.dossierDocuments} selected_documents={this.state.selectedDocuments.length > 0 ? this.state.selectedDocuments : undefined}/>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-6 text-right">
                                { this.props.dossier_id != null &&
                                    <button id="btnDelete" type="button" className="btn btn-lg btn-link text-danger ml-4" onClick={this.confirmDelete}>
                                        {lang.get('messages.borrar_expediente')}
                                    </button>
                                }
                                <a href="/dossiers" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                                    {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default DossierForm;

if (document.getElementById('DossierForm')) {
    ReactDOM.render(<DossierForm />, document.getElementById('DossierForm'));
}
